<template>
  <section
    v-if="isLoaded"
    :id="`module-${id}`"
    class="module"
  >
    <div class="module__content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Module',
  components: {
  },
  props: {
    id: {
      type: String
    },
    isLoaded: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Module
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Composer main (wrapper) component
 * @since 2021-08-17
**/

$component: 'module';

.#{$component} {
  height: 100%;
  z-index: 0;
  background-color: $white;

  &__content {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 100%;
    @include padding(map-get($spacers, 3) map-get($spacers, 4));
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
